import { z } from "zod";

export type ReplaySession = Readonly<{ viewer_url: string; ready: boolean }>;

export type ReplayLaunchIdentity = Readonly<{
  requestId: string;
  coworldId: string;
  replayUri: string;
  elevatedPrivileges: boolean;
}>;

export type ReplayLaunch = ReplaySession &
  Readonly<{
    id: "launch";
    responseReceivedAt: number;
    sessionShared: boolean;
  }>;

export type ReplayReadiness = Readonly<{
  id: "readiness";
  readyAt: number;
  healthPollCount: number;
}>;

export const replaySessionSchema = z.object({
  viewer_url: z.string(),
  ready: z.boolean(),
});
export const replaySessionResultSchema = replaySessionSchema.extend({
  responseReceivedAt: z.number(),
});
export type ReplaySessionResult = Readonly<
  z.infer<typeof replaySessionResultSchema>
>;
